import { DatePicker } from 'antd';

import { styled } from '@mui/material';

export const DatePickerStyled = styled(DatePicker)`
  width: 100%;
  height: 40px;
  &.ant-picker-focused {
    .ant-picker-input-placeholder {
      &:hover {
        border-color: ${({ theme }) => theme.vars.palette.primary.main};
      }
    }
    &:hover {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
  &:hover {
    input {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;

export const RangeDatePickerStyled = styled(DatePicker.RangePicker)`
  width: 100%;
  height: 40px;
  &.ant-picker-focused {
    .ant-picker-input-placeholder {
      &:hover {
        border-color: ${({ theme }) => theme.vars.palette.primary.main};
      }
    }
    &:hover {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
  &:hover {
    input {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
    border-color: ${({ theme }) => theme.vars.palette.primary.main};
  }
`;
